import { REPORT_POST } from "../constants/report";

export const reportPost = (payload) => {
    return {
        type: REPORT_POST,
        payload,
    };
};
